import React, { useState } from 'react';
import {
  Init,
  Passed,
  Question,
  TryAgain,
  AnswerFailed,
} from './QuestionFlow';
import { STEP_ENUM } from './enum';

const STEP_MAP = {
  'INIT': Init,
  'QUESTION': Question,
  'PASSED': Passed,
  'TRYAGAIN': TryAgain,
  'ANSWERFAILED': AnswerFailed,
};

const QuestionBox = () => {
  const [{ step, params }, setStep] = useState({
    step: STEP_ENUM.INIT,
    params: {},
  });

  const CurStep = STEP_MAP[step];
  params.setNext = setStep;

  return (
    <CurStep config={params} />
  );
};


export default QuestionBox;
